import GenericCatalogPage from "./GenericCatalogPage";
import { Wrench } from "lucide-react";

export default function Techniques() {
  return (
    <GenericCatalogPage
      title="Técnicas"
      description="Administre las técnicas de análisis"
      icon={Wrench}
      apiKey="techniques"
      testIdPrefix="technique"
    />
  );
}
